import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';

/**
 * Routes for fleet-API partners (e.g. MOQO). Gated by `requiresFleetApis` so
 * the section is reachable only when `rp-partner-configs.useFleetApis === true`
 * for the logged-in user's partner.
 *
 * The pages are scaffolds in Phase 2; the real list / detail / transactions
 * UIs land in Phases 3-5 per `concept/01-concept-and-implementation-plan.md`.
 */

const Body = () => import('@/components/body.vue');
const SubFleetList = () => import('@/pages/partner/fleet-operations/sub-fleets/SubFleetList.vue');
const SubFleetDetail = () =>
  import('@/pages/partner/fleet-operations/sub-fleets/SubFleetDetail.vue');
const TransactionList = () =>
  import('@/pages/partner/fleet-operations/transactions/TransactionList.vue');
const FleetOperationOrderDetail = () =>
  import('@/pages/partner/fleet-operations/orders/FleetOperationOrderDetail.vue');
const PartnerExportCenter = () => import('@/pages/partner/exports/PartnerExportCenter.vue');

export const partnerFleetOperationsRoutes: AppRouteRecordRaw[] = [
  {
    path: '/partner/fleet-operations',
    component: Body,
    meta: {
      requiresAuth: true,
      requiresFleetApis: true,
      breadcrumb: 'Fleet Operations',
    },
    children: [
      {
        path: 'sub-fleets',
        name: 'PartnerSubFleetList',
        component: SubFleetList,
        meta: {
          requiresFleetApis: true,
          title: 'Sub-fleets | ryd Portal',
          breadcrumb: 'Sub-fleets',
        },
      },
      {
        path: 'sub-fleets/:fleetId',
        name: 'PartnerSubFleetDetail',
        component: SubFleetDetail,
        meta: {
          requiresFleetApis: true,
          title: 'Sub-fleet detail | ryd Portal',
          breadcrumb: 'Sub-fleet detail',
        },
      },
      {
        path: 'transactions',
        name: 'PartnerFleetOperationsTransactions',
        component: TransactionList,
        meta: {
          requiresFleetApis: true,
          title: 'Sub-fleet Transactions | ryd Portal',
          breadcrumb: 'Transactions',
        },
      },
      {
        path: 'orders/order-detail',
        name: 'PartnerFleetOperationOrderDetail',
        component: FleetOperationOrderDetail,
        meta: {
          requiresFleetApis: true,
          title: 'Order detail | ryd Portal',
          breadcrumb: 'Order detail',
        },
      },
    ],
  },
  {
    path: '/account-management/exports',
    component: Body,
    meta: {
      requiresAuth: true,
      requiresFleetApisOrSubFleet: true,
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: '',
        name: 'PartnerExportCenter',
        component: PartnerExportCenter,
        meta: {
          requiresFleetApisOrSubFleet: true,
          title: 'Partner Export Centre | ryd Portal',
          headTitle: 'Export Centre',
          breadcrumb: 'Export Centre',
          i18nModules: [ETranslationModule.partnerExports],
        },
      },
    ],
  },
  // Backward-compat redirect: Exports moved to Account Management.
  { path: '/partner/exports', redirect: '/account-management/exports' },
];
